import { render, staticRenderFns } from "./binnacle.vue?vue&type=template&id=b80b199c&"
import script from "./binnacle.vue?vue&type=script&lang=js&"
export * from "./binnacle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports